import {
  ChangeDetectionStrategy,
  Component,
  HostBinding,
  inject,
  Input,
  OnChanges,
} from '@angular/core';

import type {
  CanvasElementBindings,
  CanvasElementDataInputPayload,
  CanvasElementId,
  IoConfig,
  PropsOf,
} from '@blaze-runtime/engine-domain';
import { ProjectContextFacade } from '@blaze-shared/app-state-data-access';
import { UserAccessRolesService } from '@blaze-shared/auth-data-access';
import { type RenderElementContext, type ViewportMode } from '@blaze-shared/elements-domain';

import type {
  CanvasElementComponent,
  ComponentSlotData,
} from '../../canvas-elements/element-component';

@Component({
  selector: 'be-page-break',
  templateUrl: './page-break.component.html',
  styleUrls: ['./page-break.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class PageBreakComponent implements CanvasElementComponent<'pageBreak'>, OnChanges {
  private readonly projectContextFacade = inject(ProjectContextFacade);
  private readonly userAccessRolesService = inject(UserAccessRolesService);

  @Input() elementId: CanvasElementId | undefined;
  @Input() elementContext: RenderElementContext | undefined;
  @Input() elementType!: 'pageBreak';
  @Input() ns?: CanvasElementId;
  @Input() props: PropsOf<'pageBreak'> | undefined;
  @Input() dataInput: CanvasElementDataInputPayload;
  @Input() bindingResults: CanvasElementBindings = {};
  @Input() ioConfig?: IoConfig;
  @Input() isInEditor = false;
  @Input() slots?: ComponentSlotData<'pageBreak'>;
  @Input() visible?: boolean | any[]; // Fixme [MG] It can be an array of whatever "visible" data source will provide
  @Input() viewportMode: ViewportMode | undefined;

  // Mirrors CanvasElementBaseComponent.isHiddenEditor - the component does not extend the base class
  @HostBinding('class.be-hidden-editor') isHiddenEditor = false;

  ngOnChanges(): void {
    this.isHiddenEditor = this.computeIsHiddenEditor();
  }

  private computeIsHiddenEditor(): boolean {
    if (this.bindingResults?.['visible'] && !this.visible) {
      return true;
    }
    const accessRoles = this.props?.content?.visible?.accessRoles;
    if (accessRoles?.length) {
      return !this.userAccessRolesService.isCurrentUserInAccessRoles(accessRoles);
    }

    return false;
  }
}
